import { Dialog, DialogContent, DialogTitle, Tab, Tabs } from "@mui/material";
import { useTabs } from "../../hooks/ui";
import ToDoTemplateList from "../ToDoTemplateList";
import { useProfile } from "../../context/ProfileContext";

export default function ManageToDoDialog({ onChange, ...disclosureProps }) {
  const { currentTab, setCurrentTab } = useTabs(["created", "upcoming"]);
  const { profile } = useProfile();
  return (
    <>
      <Dialog {...disclosureProps} maxWidth="xs" fullWidth>
        <DialogTitle component={"div"}>
          <Tabs
            value={currentTab}
            onChange={(event, val) => setCurrentTab(val)}
            centered
            sx={{ height: "3%", boxSizing: "border-box" }}
          >
            <Tab label="Created by me" value={"created"} />
            <Tab label="Upcoming" value={"upcoming"} />
          </Tabs>
        </DialogTitle>
        <DialogContent>
          <ToDoTemplateList
            filters={
              currentTab == "created"
                ? {
                    created_by_id: profile.uuid,
                  }
                : { upcoming: true, is_active: true }
            }
            onChange={onChange}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
